<app-sidebar>
  <div class="trust-data-viewer-container">
    <div class="page-nav">
      <button mat-stroked-button type="button" class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ backLabel }}
      </button>
      <button mat-stroked-button type="button" (click)="newTrustSearch()">
        <mat-icon>account_balance</mat-icon>
        New trust search
      </button>
    </div>

    <div class="header-section">
      <div>
        <h1>Trust Search Results</h1>
        <p class="searched-trust">Trust number: <strong>{{ getSearchedTrustLabel() }}</strong></p>
        <p class="meta-line" *ngIf="requestStatus">
          Status: {{ formatRequestStatusLabel() }}
          <span *ngIf="formatFreeUntil()"> · Free until {{ formatFreeUntil() }}</span>
        </p>
      </div>
    </div>

    <mat-card class="request-status-card" *ngIf="waitingForRequest">
      <mat-card-content class="request-status-content">
        <div class="request-status-row">
          <mat-spinner diameter="24"></mat-spinner>
          <div>
            <p class="request-status-title">Request is {{ formatRequestStatusLabel().toLowerCase() }}</p>
            <p class="request-status-subtitle">
              We are still fetching trust matches. This screen refreshes automatically.
            </p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card
      class="request-status-card request-status-error"
      *ngIf="!loading && !waitingForRequest && (requestStatus === 'FAILED' || requestStatus === 'CANCELLED')">
      <mat-card-content>
        <div class="request-status-row">
          <mat-icon color="warn">error</mat-icon>
          <div>
            <p class="request-status-title">Request {{ formatRequestStatusLabel().toLowerCase() }}</p>
            <p class="request-status-subtitle">{{ getRequestFailureMessage() }}</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading trust data...</p>
    </div>

    <mat-card
      class="request-status-card"
      *ngIf="!loading && !waitingForRequest && requestStatus === 'COMPLETE' && (requestResultCode === 'NO_MATCH' || matches.length === 0)">
      <mat-card-content>
        <div class="request-status-row">
          <mat-icon>search_off</mat-icon>
          <div>
            <p class="request-status-title">No match</p>
            <p class="request-status-subtitle">
              {{ loadDataErrorMessage || 'No trust matches were found for this trust number.' }}
            </p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card
      class="match-card"
      *ngFor="let match of matches; let i = index"
      [hidden]="loading || waitingForRequest || requestStatus !== 'COMPLETE'">
      <mat-card-content>
        <div class="match-header">
          <h2>{{ match.name || ('Trust match ' + (i + 1)) }}</h2>
          <div class="match-meta">
            <div><span class="label">Trust number</span><span class="value">{{ match.trustNumber || '—' }}</span></div>
            <div><span class="label">Alt number</span><span class="value">{{ match.altTrustNumber || '—' }}</span></div>
            <div><span class="label">Masters office</span><span class="value">{{ match.mastersOffice || '—' }}</span></div>
            <div><span class="label">Registration date</span><span class="value">{{ match.registrationDate || '—' }}</span></div>
          </div>
        </div>

        <h3 class="trustees-heading">Trustees</h3>
        <div class="table-wrap" *ngIf="match.trustees?.length; else noTrustees">
          <table mat-table [dataSource]="match.trustees" class="trustees-table">
            <ng-container matColumnDef="fullName">
              <th mat-header-cell *matHeaderCellDef>Full name</th>
              <td mat-cell *matCellDef="let row">{{ row.fullName || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="surname">
              <th mat-header-cell *matHeaderCellDef>Surname</th>
              <td mat-cell *matCellDef="let row">{{ row.surname || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="idNumber">
              <th mat-header-cell *matHeaderCellDef>ID number</th>
              <td mat-cell *matCellDef="let row">{{ row.idNumber || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="age">
              <th mat-header-cell *matHeaderCellDef>Age</th>
              <td mat-cell *matCellDef="let row">{{ row.age ?? '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let row">{{ row.status || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="riskBand">
              <th mat-header-cell *matHeaderCellDef>Risk band</th>
              <td mat-cell *matCellDef="let row">{{ row.riskBand || '—' }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="trusteeColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: trusteeColumns"></tr>
          </table>
        </div>
        <ng-template #noTrustees>
          <p class="empty-trustees">No trustees returned for this match.</p>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </div>
</app-sidebar>
